(function () {
  if (customElements.get('ce-lazy-load-video') !== undefined) {
    return;
  }

  class LazyLoadVideo extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        video: '[data-lazy-load-video-video]',
      };

      this.elements = null;
      this.intersectionObserver = null;
    }

    parsedCallback() {
      this.elements = {
        video: this.querySelector(this.selectors.video),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            if (getComputedStyle(this.elements.video).getPropertyValue('display') === 'none') {
              return;
            }

            const sources = this.elements.video.children;
            for (let source of sources) {
              source.src = source.dataset.src;
            }

            this.elements.video.load();
            this.intersectionObserver.unobserve(this);
          }
        }
      };

      const options = {
        rootMargin: '0px 0px 1400px 0px',
      };

      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }
  }

  customElements.define('ce-lazy-load-video', LazyLoadVideo);
})();
